import React from 'react'
import CustomerInformations from './CustomerInformations'
import LegalFormalities from './LegalFormalities'

interface IProps {
  setActiveTabKey: (key: string) => void
}

const Summary = (props: IProps) => {
  const { setActiveTabKey } = props

  return (
    <>
      <CustomerInformations />
      <LegalFormalities setActiveTabKey={setActiveTabKey} />
    </>
  )
}

export default Summary
